import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetCardCustomizationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetCardCustomizationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setCardCustomization = (request: SetCardCustomizationRequest, options?: CashRequestOptions) =>
  post<SetCardCustomizationRequest, SetCardCustomizationResponse>('/2.0/cash/set-card-customization', request, {
    ...options,
    rejectOnError: true,
  })
